import { AxiosError } from 'axios';
import instance from '../config/axios';

export const createManifest = async (accessToken: string) => {
  try {
    const response = await instance({
      url: '/api/v1/manifest/create',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return { status: response.status, data: response.data };
  } catch (e) {
    console.log(e);
    const error = e as AxiosError;
    return {
      status: error.response?.status,
      data: (error.response?.data as { message: string }).message,
    };
  }
};
